import { destroyByInstance } from "@/components/HBModal/ModalWrap";
import { createRef } from "react";
import { verify } from "../../../services";
import HBMessage from "../../HBMessage";
import HBConfirm from "../../HBModal/confirm";
import VerifyInput from "../VerifyInput";

let prevDialog = null;

/**
 * 滑块验证弹框
 * @param {Object} props
 * @param {string} props.captchakey 从接口报错信息中获取，可以直接从data中拿，虽然值放在header中，但request方法已默认取出来放到data里了
 * @param {string} props.title 标题 弹框的提示内容, 也有默认
 * @param {string} props.id id当一个页面会同时存在多个滑动验证时，请取一个不会冲突的id
 * @param {string} props.type 验证场景，默认 other， 其他场景有：regiseter reset
 *
 * @example  VerifyConfirm({ captchakey: result.captchakey });
 */
export default function VerifyConfirm({
  captchakey,
  title = "您操作的频率过快，系统判断您可能是机器人。完成以下验证，可以继续进行相关操作",
  id = "nc",
  type = "other",
}) {
  let verifyRef = createRef();
  let verifyData = null;

  destroyByInstance(prevDialog?.instance);

  const confirm = HBConfirm.open({
    title: "提示",
    visibleControl: true,
    content: (
      <div>
        <div style={{ paddingBottom: "16px" }}>{title}</div>
        <VerifyInput
          id={id}
          ref={verifyRef}
          type={type}
          onOk={(data) => {
            verifyData = data;
          }}
        />
      </div>
    ),
    okText: "确定",
    async onOk() {
      if (verifyData) {
        verify({ key: captchakey, ...verifyData, values: "pass" })
          .then((data) => {
            if (data.err) {
              HBMessage.error("验证失败，请重新验证");
              verifyRef.current.reset();
            } else {
              confirm.destroy();
            }
          })
          .catch(() => {
            HBMessage.error("验证失败，请重新验证");
            verifyRef.current.reset();
          });
      } else {
        HBMessage.error("请先完成滑动验证");
      }
    },
    onCancel() {
      confirm.destroy();
    },
  });

  prevDialog = confirm;

  return confirm;
}
